import { v1 as uuid } from 'uuid';
import { CommonRequestService } from './common-request.service';
import { AppSettings } from './../app.settings';
import { CommonUtilityService } from './common-utility.service';
var AppinfoService = /** @class */ (function () {
    function AppinfoService(requestService, utilityService
    // private uuidService: v1
    ) {
        this.requestService = requestService;
        this.utilityService = utilityService;
        this.layerTypeList = [];
        this.reportTypeList = [];
        this.columnMap = {};
        this.rolesByApp = {};
        this.layerStateMap = {};
        this.filterOperators = {};
        this.refLayerMvtAttrs = {};
        this.nagParams = [];
        this.nagDirectionCrosswalk = {
            N: {
                nena: 'NORTH',
                usps: 'N'
            },
            NORTH: {
                nena: 'NORTH',
                usps: 'N'
            },
            NW: {
                nena: 'NORTHWEST',
                usps: 'NW'
            },
            NORTHWEST: {
                nena: 'NORTHWEST',
                usps: 'NW'
            },
            NE: {
                nena: 'NORTHEAST',
                usps: 'NE'
            },
            NORTHEAST: {
                nena: 'NORTHEAST',
                usps: 'NE'
            },
            S: {
                nena: 'SOUTH',
                usps: 'S'
            },
            SOUTH: {
                nena: 'SOUTH',
                usps: 'S'
            },
            SW: {
                nena: 'SOUTHWEST',
                usps: 'SW'
            },
            SOUTHWEST: {
                nena: 'SOUTHWEST',
                usps: 'SW'
            },
            SE: {
                nena: 'SOUTHEAST',
                usps: 'SE'
            },
            SOUTHEAST: {
                nena: 'SOUTHEAST',
                usps: 'SE'
            },
            E: {
                nena: 'EAST',
                usps: 'E'
            },
            EAST: {
                nena: 'EAST',
                usps: 'E'
            },
            W: {
                nena: 'WEST',
                usps: 'W'
            },
            WEST: {
                nena: 'WEST',
                usps: 'W'
            }
        };
        this._customerProfile = {
            discrepancyAgencyId: null,
        };
    }
    // getAppinfo(successCallback?, errorCallback?) {
    // 	const url = AppSettings.serviceRootUrl + 'admin/appInfo';
    // 	const params = new URLSearchParams();
    // 	const options = new RequestOptions();
    // 	params.set('application', AppSettings.appName);
    // 	options.params = params;
    // 	this.requestService.requestGet(url, options, (rsp) => {
    // 		this.setLayerTypeList(rsp.data.layer_type_list);
    // 		this.setColumnMap(rsp.data.gdo);
    // 		this.setQaRules(rsp.data.qa_rules);
    // 		if (successCallback) {
    // 			successCallback();
    // 		}
    // 	}, errorCallback);
    // }
    AppinfoService.prototype.getAppinfo = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'admin/appInfo';
            var params = {
                applications: JSON.stringify([AppSettings.appName])
            };
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                _this.setColumnMap(rsp.data.gdo);
                _this.setRoles(rsp.data.roles);
                _this.setLayerStateList(rsp.data.azgiv_layer_state);
                _this.setFilterOperators(rsp.data.gfo_ui);
                _this.setLbDataTypesMap(rsp.data.lb_data_types);
                _this.setRefLayerMvtAttrs(rsp.data.ref_layer_mvt_attrs);
                _this.setSampleAddresses(rsp.data.azgiv_addr_examples);
                _this.setNagParams(rsp.data.nag_addition_params);
                _this.setNagPostypeCrosswalk(rsp.data.nag_postype_crosswalk);
                // this.setQaRules(rsp.data.qa_rules);
                console.log('app info obtained.');
                resolve();
            }, function () {
                reject();
            });
        });
    };
    AppinfoService.prototype.getAppinfoByCustomer = function (customerId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // resolve()
            var url = AppSettings.serviceRootUrl + 'admin/customerAppInfo';
            var params = {
                application: AppSettings.appName,
                customerId: customerId
            };
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                _this.setLayerTypeList(rsp.data.layer_type_list);
                _this.setReportTypeList(rsp.data.report_type_list);
                _this.setCustomerProfile(rsp.data.customer_profile);
                resolve();
            }, function () {
                reject();
            });
        });
    };
    AppinfoService.prototype.getSessionUuid = function () {
        return this.sessionUuid;
    };
    AppinfoService.prototype.generateSessionUuid = function () {
        this.sessionUuid = uuid();
    };
    // Set layerTypeList
    AppinfoService.prototype.setLayerTypeList = function (data) {
        var _this = this;
        if (!data) {
            console.log('No layer_type_list provided.');
            return;
        }
        this.layerTypeList = [];
        data.forEach(function (d) {
            var tableName = d.glt_table_name;
            var col = Object.keys(_this.columnMap).find(function (c) { return _this.columnMap[c].sourceTab === tableName; }) || '';
            var prefix = col.split('_')[0];
            _this.layerTypeList.push({
                name: d.glt_name,
                nameShort: d.glt_name_short,
                code: d.glt_cd,
                id: d.glt_id,
                geomType: d.glt_geom_type,
                scope: d.glt_scope,
                status: d.glt_status,
                definedBy: d.glt_defined_by,
                parentTypeCode: d.glt_parent_cd,
                hasCommon: d.glt_common,
                tableName: tableName,
                isCollaborative: d.gtc_collaborative,
                isStateMaintained: d.gtc_state_maintained,
                colPrefix: prefix
            });
        });
    };
    AppinfoService.prototype.setReportTypeList = function (data) {
        var _this = this;
        if (!data) {
            console.log('No report_type_list provided.');
            return;
        }
        this.reportTypeList = [{
                label: 'ALL',
                value: 'ALL'
            }];
        data.forEach(function (d) {
            _this.reportTypeList.push({
                label: d.gqr_types,
                value: d.gqr_types
            });
        });
    };
    AppinfoService.prototype.setCustomerProfile = function (data) {
        if (!data || !data[0]) {
            return;
        }
        this._customerProfile.discrepancyAgencyId = data[0].cus_discrp_ag_id;
        // if (data[0].cus_centroid) {
        // 	const centroidRaw = data[0].cus_centroid.split(' ');
        // 	this._customerProfile.centroidLatlong = [Number(centroidRaw[1]), Number(centroidRaw[0])];
        // }
    };
    Object.defineProperty(AppinfoService.prototype, "customerProfile", {
        get: function () {
            return JSON.parse(JSON.stringify(this._customerProfile));
        },
        enumerable: true,
        configurable: true
    });
    AppinfoService.prototype.setColumnMap = function (data) {
        if (!data) {
            console.log('No Gdo Info.');
            return;
        }
        // convert Gdo data to columnMap
        for (var i = 0; i < data.result.length; i++) {
            this.columnMap[data.result[i].col_name] = {
                name: data.result[i].col_name,
                heading: data.result[i].col_heading,
                width: data.result[i].col_size,
                type: data.result[i].col_type,
                sourceTab: data.result[i].src_tab,
                align: data.result[i].align,
                isDisplay: data.result[i].display === 'Y' ? true : false,
                isPrimeKey: data.result[i].prim_key === 'Y' ? true : false,
                isGto: data.result[i].gto === 'Y' ? true : false,
                seq: data.result[i].col_seq,
                fkCol: data.result[i].fk_col,
                fkTab: data.result[i].fk_tab // Foreign key table
            };
        }
    };
    AppinfoService.prototype.setRoles = function (data) {
        if (!data) {
            return;
        }
        this.rolesByApp = this.utilityService.arrayToObjectByFirstProp(data);
    };
    AppinfoService.prototype.setLayerStateList = function (data) {
        if (!data) {
            console.log('azgiv_layer_state does not exist.');
            return;
        }
        this.layerStateMap = this.utilityService.arrayToObjectByFirstProp(data);
    };
    AppinfoService.prototype.setFilterOperators = function (data) {
        var _this = this;
        if (!data) {
            console.log('No gfo_ui provided.');
            return;
        }
        var typeMapping = {
            t: 'text',
            j: 'jsonb',
            b: 'bool',
            n: 'numeric',
            d: 'date',
            u: 'uuid'
        };
        data.forEach(function (d) {
            if (!_this.filterOperators[d.op]) {
                _this.filterOperators[d.op] = {
                    name: d.op,
                    label: d.lbl,
                    sq: d.seq,
                    compatibleColTypes: [],
                };
            }
            _this.filterOperators[d.op].compatibleColTypes.push(typeMapping[d.typ]);
        });
        // // 'is empty' and 'not empty' are not in the database. Add them manually
        // this.filterOperators['is empty'] = {
        // 	name: 'is empty',
        // 	label: 'isEmpty',
        // 	compatibleColTypes: ['text']
        // }
        // this.filterOperators['not empty'] = {
        // 	name: 'not empty',
        // 	label: 'notEmpty',
        // 	compatibleColTypes: ['text']
        // }
    };
    AppinfoService.prototype.setLbDataTypesMap = function (data) {
        if (!data) {
            console.log('No gfo_data_types provided.');
            return;
        }
        this.lbDataTypesMap = data;
    };
    AppinfoService.prototype.setRefLayerMvtAttrs = function (data) {
        var _this = this;
        if (!data) {
            console.log('No ref_layer_mvt_attrs provided.');
            return;
        }
        data.forEach(function (d) {
            if (!_this.refLayerMvtAttrs[d.ref_layer]) {
                _this.refLayerMvtAttrs[d.ref_layer] = {};
            }
            _this.refLayerMvtAttrs[d.ref_layer][d.model] = {
                model: d.model,
                attrList: d.attr_list
            };
        });
    };
    AppinfoService.prototype.setSampleAddresses = function (data) {
        if (!data) {
            console.log('No azgiv_addr_examples provided.');
            return;
        }
        this.sampleAddresses = data;
    };
    AppinfoService.prototype.setNagParams = function (data) {
        if (!data) {
            return;
        }
        this.nagParams = data.map(function (i) {
            return {
                standardName: i.gss_col_name,
                nctId: i.nct_id,
                isSpatial: i.is_spatial,
                source: i.source,
                nctName: i.gss_nct_name // TODO
            };
        });
    };
    AppinfoService.prototype.setNagPostypeCrosswalk = function (data) {
        var _this = this;
        if (!data) {
            return;
        }
        this.nagPostypeCrosswalk = {};
        data.forEach(function (i) {
            _this.nagPostypeCrosswalk[i.street_postyp] = {
                postType: i.street_postyp,
                nena: i.nena_postyp,
                usps: i.usps_postyp,
                cusId: i.cus_id
            };
        });
    };
    AppinfoService.prototype.findGeneralCol = function (lbColType) {
        if (!lbColType) {
            return;
        }
        var generalColType;
        for (var _i = 0, _a = Object.keys(this.lbDataTypesMap); _i < _a.length; _i++) {
            var t = _a[_i];
            if (this.lbDataTypesMap[t].indexOf(lbColType.toLowerCase()) !== -1) {
                generalColType = t;
                break;
            }
        }
        if (!generalColType && lbColType.toLowerCase().startsWith('timestamp')) {
            generalColType = 'date';
        }
        return generalColType;
    };
    return AppinfoService;
}());
export { AppinfoService };
